import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core';
var breadCrumbStyle = function breadCrumbStyle(props) {
  var _getThemeData = getThemeData(props, 'common'),
    primary6 = _getThemeData.primary6;
  return css([".ant-breadcrumb.ant-breadcrumb{span:not(:last-child){:hover{.ant-breadcrumb-link{color:", ";cursor:pointer;}}}}"], primary6);
};
export default breadCrumbStyle;